module.exports = __webpack_public_path__ + "img/ods-logo-header-sm.464053fb.png";